module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"itemAdded":"{name} has been added to cart","viewCart":"View Cart","close":"Close"},"ar":{"itemAdded":"تمت اضافة {name} الى عربة التسوق","viewCart":"عربة التسوق","close":"اغلاق"}}')
  delete Component.options._Ctor
}
